import { create } from 'zustand'
import { SlotVoucherSummary } from '../model/SlotVoucherSummary'

interface IVoucherStore {
  isShowVoucherSelectPopup: boolean
  isShowVoucherTotalWinPopup: boolean
  tempSlotVoucher: SlotVoucherSummary | null
  currentVoucherId: string
  fixedStake: number
  totalPayout: number
  totalSpin: number
  remainSpin: number
  expireDate: Date

}

export const useVoucherStore = create<IVoucherStore>(() => ({
  isShowVoucherSelectPopup: false,
  isShowVoucherTotalWinPopup: false,
  tempSlotVoucher: null,
  currentVoucherId: '',
  fixedStake: 0,
  totalPayout: 0,
  totalSpin: 0,
  remainSpin: 0,
  expireDate: new Date(),
}))
